import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  pointer: {
    backgroundColor: 'rgb(248, 248, 248)',
    borderRadius: '6px',
    boxShadow: '0 1px 4px 0 rgba(0,0,0,0.37)',
    height: '12px',
    transform: 'translate(-6px, -1px)',
    width: '12px',
  },
});
